import {
  NavLink as RouterLink,
  useLocation,
  useNavigate,
} from 'react-router-dom'
// material
import { experimentalStyled as styled } from '@material-ui/core/styles'
import {
  Box,
  Button,
  AppBar,
  Toolbar,
  Container,
  Stack,
  Tooltip,
  Typography,
  Popover
} from '@material-ui/core'
// hooks
import useOffSetTop from '../../hooks/useOffSetTop'
// components
import Logo from '../../components/Logo'
import egovlogo from '../../pages/E-Gov/images/newLogoText.png'
import egovlogoSm from '../../pages/E-Gov/images/newLogo.png'
import Label from '../../components/Label'
import { MHidden } from '../../components/@material-extend'
//
import MenuDesktop from './MenuDesktop'
import MenuMobile from './MenuMobile'
import navConfig from './MenuConfig'
import { PATH_PAGE } from 'src/routes/paths'
import { admin, baseURL, mda, user } from 'src/pages/E-Gov/defaultValue'
import { useState } from 'react'

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 80

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP,
  },
}))

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: 'none',
}))

// ----------------------------------------------------------------------

export default function MainNavbar() {
  const isOffset = useOffSetTop(100)
  const { pathname } = useLocation()
  const isHome = pathname === '/'
  const navigate = useNavigate()

   const [loginAnchor, setLoginAnchor] = useState(null)
  const loginOpen = Boolean(loginAnchor)
  const loginId = loginOpen ? 'login-popover' : undefined

  const handleOpenLogin = (e) => setLoginAnchor(e.currentTarget)
  const handleCloseLogin = () => setLoginAnchor(null)
  const goTo = (url) => {
    handleCloseLogin()
    window.location.href = url
    // or use: navigate(urlRelativeToRouter)
  }


  return (
    // <AppBar color={isHome ? 'transparent' : 'default'} sx={{ boxShadow: 0 }}>
    <AppBar sx={{ boxShadow: 'none' }}>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            bgcolor: 'primary.main',
            boxShadow: 'none',
            // bgcolor: 'background.default',
            // height: { md: APP_BAR_DESKTOP - 16 },
          }),
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            boxShadow: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <RouterLink to="/">
            {/* desktop/tablet */}
            <Box
              component="img"
              src={egovlogo}
              alt="eGOVERNMENT logo"
              sx={{
                display: { xs: 'none', sm: 'none', md: 'block' },
                width: 200,
                maxWidth: '100%',
                height: 'auto',
                objectFit: 'cover',
              }}
            />
            {/* small screens */}
            <Box
              component="img"
              src={egovlogoSm}
              alt="eGOVERNMENT logo"
              sx={{
                display: { sm: 'block', md: 'none' },
                minWidth: 40,
                minHeight: 40,
                width: 40,
                height: 40,
                objectFit: 'cover',
                flexShrink: 0,
              }}
            />
          </RouterLink>

          {/* <Label color="info" sx={{ ml: 1 }}>
            v2.1.0
          </Label> */}

          <MHidden width="mdDown">
            <MenuDesktop
              isOffset={isOffset}
              isHome={isHome}
              navConfig={navConfig}
            />
          </MHidden>

          {/* <Button
            variant="contained"
            target="_blank"
            href="https://material-ui.com/store/items/e-Gov-dashboard/"
          >
            Purchase Now
          </Button> */}
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: { md: 3, xs: 1 },
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                display: 'inline-block',
                '&:hover .tooltip-box': {
                  opacity: 1,
                  visibility: 'visible',
                },
              }}
            >
              <Box
                // onClick={() => navigate(PATH_PAGE.loginNew)}
                onClick={() =>
                  (window.location.href = `${baseURL}/account/login-eGov`)
                }
                className="icon-image-nav"
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: 'primary.main',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              />
              <Box
                className="tooltip-box"
                sx={{
                  position: 'absolute',
                  margin: 'auto',
                  maxHeight: 80,
                  maxWidth: 120,
                  top: 50,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  bgcolor: '#fff',
                  color: '#000',
                  p: '8px 12px',
                  borderRadius: '6px',
                  fontSize: '15px',
                  fontWeight: 500,
                  lineHeight: 1.4,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                  opacity: 0,
                  visibility: 'hidden',
                  transition: 'all 0.3s ease',
                  minWidth: '200px',
                  textAlign: 'center',
                  zIndex: 10,
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: '-10px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    borderLeft: '10px solid transparent',
                    borderRight: '10px solid transparent',
                    borderBottom: '10px solid #fff',
                  },
                }}
              >
                Report anonymous: <br />{' '}
                <Typography sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                  Click to blow the whistle
                </Typography>
              </Box>
            </Box>

            <Button
              aria-describedby={loginId}
              sx={{
                height: '35px',
                fontSize: '17px',
                width: { md: '100px', xs: '80px' },
                fontWeight: 'normal',
                bgcolor: '#ffffffff',
                color: 'primary.main',
                '&:hover': {
                  bgcolor: '#c6cbbbff',
                  color: 'primary.main',
                },
              }}
              variant="contained"
              onClick={() => goTo(`${baseURL}/account/login-eGov`)}
              // onClick={handleOpenLogin}
            >
              Login
            </Button>

            <Popover
              id={loginId}
              open={loginOpen}
              anchorEl={loginAnchor}
              onClose={handleCloseLogin}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{ sx: { p: 1.5, borderRadius: 2, minWidth: 220 } }}
            >
              <Stack spacing={1}>
                <Button
                  fullWidth
                  size="small"
                  variant="outlined"
                  onClick={() =>
                    goTo(`${baseURL}/account/login-eGov`)
                  }
                >
                  Citizen Login
                </Button>
                <Button
                  fullWidth
                  size="small"
                  variant="outlined"
                  onClick={() => goTo(`${mda}/admin/login`)}
                >
                  MDA Login
                </Button>
                <Button
                  fullWidth
                  size="small"
                  variant="outlined"
                  onClick={() =>
                    goTo(`${admin}/admin/login`)
                  }
                >
                  Admin Login
                </Button>
              </Stack>
            </Popover>
            <Button
              sx={{
                height: '35px',
                fontSize: '17px',
                fontWeight: 'normal',
                width: { md: '100px', xs: '80px' },
                bgcolor: '#AAF27F',
                color: 'primary.main',
                '&:hover': {
                  bgcolor: '#709821ff', // darker green on hover
                  color: 'primary.main', // change text color on hover (optional)
                },
              }}
              variant="contained"
              onClick={() =>
                (window.location.href = `${baseURL}/account/signup-eGov`)
              }
              // onClick={() => window.location.href = 'http://egovern.skyniche.website/account/register'}
              // onClick={() => navigate(PATH_PAGE.signup)}
            >
              Register
            </Button>
          </Stack>

          <MHidden width="mdUp">
            <MenuMobile
              isOffset={isOffset}
              isHome={isHome}
              navConfig={navConfig}
            />
          </MHidden>
        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  )
}
